module.exports = __webpack_public_path__ + "media/images/ui__boxBg-2b4263717d8d7e172b69acef589c120a.png";